/**
 *
 */
export default {
  /**
   * Get min height as css string for a chart with n bars.
   * @param {number} n - amount of bars in chart
   */
  getChartMinHeight: function(n) {
    var val = !n || n <= 0 ? "100%" : 13 * n + 100 + "px";
    return val;
  },
  /**
   * Builds default chart options for chart.js.
   * @param {object} overrides - Object with overrides for returned default.
   * @returns {object} default chart options with given overrides applied
   */
  defaultChartOptions: function(overrides) {
    const result = {
      maintainAspectRatio: false,
      responsive: true,
      legend: { display: false },
      title: {
        display: false
      },
      scaleShowValues: true,
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || "";
            if (label) {
              label += ": ";
            }
            label += Math.round(tooltipItem.value * 100) / 100;
            return label;
          }
        }
      },
      scales: {
        yAxes: [
          {
            gridLines: {
              display: false
            },
            ticks: {
              autoSkip: false,
              mirror: true,
              padding: -10,
              fontColor: "#323233",
              fontFamily: ["Montserrat", "Helvetica", "Arial", "sans-serif"],
              fontWeight: 300,
              z: 5, // above bars
              minor: {
                enabled: true,
                fontSize: 12
              }
            },
            ...overrides.yAxes
          }
        ],
        xAxes: [
          {
            ticks: {
              beginAtZero: true
            },
            ...overrides.xAxes
          }
        ]
      }
    };

    return Object.assign({}, result, overrides);
  }
};
